import { render, staticRenderFns } from "./ConfirmationDialogCreateTemplate.vue?vue&type=template&id=6ca3088c"
import script from "./ConfirmationDialogCreateTemplate.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialogCreateTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports